import React from 'react';
import PropTypes from 'prop-types';

import HeaderTopDropdown from './HeaderTopDropdown';
import HeaderTopItem from './HeaderTopItem';
import HeaderTopLocale from './HeaderTopLocale';
import HeaderTopNav from './HeaderTopNav';
import HeaderTopLeft from './HeaderTopLeft';
import HeaderTopRight from './HeaderTopRight';

const HeaderTop = ({ children }) => <div className="c-header__top">
    <div className="o-grid  o-grid---gutters-large  o-grid--bottom  u-show@desktop">
      {children}
    </div>
  </div>

HeaderTop.Dropdown = HeaderTopDropdown;
HeaderTop.Item = HeaderTopItem;
HeaderTop.Locale = HeaderTopLocale;
HeaderTop.Nav = HeaderTopNav;
HeaderTop.Left = HeaderTopLeft;
HeaderTop.Right = HeaderTopRight;

export default HeaderTop;

HeaderTop.propTypes = {
  children: PropTypes.node.isRequired,
};
